import { render } from "./EducationView.vue?vue&type=template&id=8fac10b0&scoped=true&ts=true"
import script from "./EducationView.vue?vue&type=script&lang=ts"
export * from "./EducationView.vue?vue&type=script&lang=ts"

import "./EducationView.vue?vue&type=style&index=0&id=8fac10b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fac10b0"]])

export default __exports__